<template>
    <div class="publicViewClass" style="padding-top:0">
         <div class="edit-step">
            <topicSteps :active = "3" :propList="propList1"></topicSteps>
        </div>
         <div class="app-inner show_container" style="padding:0 0 16px 0 !important;margin-bottom:80px">
            <div class="public-btn-small flex align-cen posta enposta">
            <div class="public-btn-small-plan" @click="cacelIM">
                取消导入
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="importSvae"
            >
            导入试题
           </el-button>
            </div>
           <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-file-plus"></i> 共有{{totalNum}}道题识别成功，其中{{duplicateNum}}个已经在题库列表中，请核查
            </div>
        </div>
                <div class="question-duplication-container staff_manage_center">
             <div class="public-list-container">
                 <div class="public-list-container-table">
                    <div class="public-list-container-table-header flex align-cen">
                            <div class="stclass pustclass">排序</div>
                            <div class="stsort pustclass">题目标题</div>
                            <div class="stcz pustclass">题型</div>
                            <div class="stcz1 pustclass">分数</div>
                            <div class="stcz2 pustclass"></div>
                        </div>
                     <div v-if="itemList.length">
                        <div class="public-list-container-table-row"
                        v-for="(item,index) in itemList"
                        >
                         <div class="flex align-cen" :class="item.isTrue ? 'pdd' : ''">
                          <div class="stclass pustclass">
                            {{index+1}}
                          </div>
                          <div class="stsort pustclass">
                            <p v-html="item.title"></p>
                          </div>
                           <div class="stcz pustclass">
                            {{$util.getTopicType(item.type)}}
                           </div>
                           <div class="stcz1 pustclass" style="color:red">
                             {{item.score}}
                           </div>
                           <div class="stcz2 pustclass" style="color:red;cursor: pointer;" v-if='item.duplicateList' @click="openTopicRe(item.isTrue,index,item)">
                               {{item.isTrue ? '暂不处理' : '展开处理' }}
                           </div>
                           <div class="stcz2 pustclass" v-if="!item.duplicateList">
                            -
                           </div>
                           </div>
                              <div class="topicIstru" v-if="item.isTrue">
                            <div class="duplicate-questions flex">
                                 <div class="duplicate-question">
                                 <div class="portlet">
                                            <div class="portlet-head flex align-cen">
                                                <!-- <div class="caption">试题{{index+1}}</div> -->
                                                <div class="btn-set mft flex align-cen">
                                                   <div class="btn-blue-delete" @click="deletTopic(index)">删除</div>
                                                    <div class="btn-default" @click="editTopic(item,index)">编辑</div>
                                                </div>
                                            </div>
                                           <div class="portlet-body">
                                                <div class="duplication-info-container">
                                                    <div class="ques-title flex align-cen">
                                                        <span class="ques-type">
                                                             {{$util.getTopicType(item.type)}}
                                                        </span>
                                                        <div class="qcotent">
                                                            <p v-html="item.title"></p>
                                                        </div>
                                                        <div class="ques-score">
                                                            ({{item.score}}分)
                                                        </div>
                                                    </div>
                                                    <div class="question-option-list">
                                                        <ol v-if="item.type != 9 && item.type != 5">
                                                            <li v-for="(sonitem,sonIndex) in item.answerList">
                                                               <p v-html="sonitem.content"></p>
                                                            </li>
                                                        </ol>
                                                             <div class="refAnswer" style="margin-left:-25px" v-if="item.type == 5">
                                                <div class="detailKeyWorld" v-if="item.rule">
                                                    <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                                    <p>关键字：</p>
                                                        <p v-for="(sonitem,sonIndex) in item.answerList">
                                                        {{sonitem.content}}<span v-if="sonIndex !=item.answerList.length-1">，</span>
                                                    </p>
                                                    </div>
                                                </div>
                                                <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                                            </div>
                                                    </div>
                                                    <div class="ques-answers">
                                                        <div class="test_result">
                                                            <div class="rightAnswer flex">
                                                               <span v-if="item.type != 7 && item.type != 9 && item.type != 5">
                                                                    正确答案：
                                                                    <span v-for="(sonitem,sonIndex) in item.answerList">
                                                                     <strong  v-if="sonitem.isRight == 1">
                                                                        {{Eng[sonIndex]}}
                                                                    </strong>
                                                                    </span>
                                                                </span>
                                                                <span v-if="item.type == 5" class="flex align-cen" style="color:#009aff">
                                                                        参考答案：
                                                                        <span v-html="item.refAnswer"></span>
                                                                    </span>
                                                                        <span v-if="item.type == 7">
                                                                                正确顺序：
                                                                                <span v-for="(sonitem,sonIndex) in sortedIndexes">
                                                                                    <span>
                                                                                    {{Eng[sonitem]}}
                                                                                </span>
                                                                                </span>
                                                                            </span>
                                                            </div>
                                                              <div class="rightAnswer flex">
                                                                <span>
                                                                    分数：
                                                                   
                                                                     <strong >
                                                                        {{item.score}}
                                                                    </strong>
                                                                    
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                 </div>
                            </div>
                           </div>
                        </div>
                     </div>
                     <div v-else class="no-empry">
                        暂无数据
                     </div>
                 </div>
             </div>
        </div>
         </div>
                 <!-- 打开题目编辑 -->
        <el-dialog
  title="编辑题目"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
  <div class="forminfo"> 
      <topicTemplate 
    :propData='propData'
    :propIndex="propIndex"
    ref="topicTemplate"
    @emitFun="handleData"
    ></topicTemplate>
    <div class="authbtn flex align-cen">
             <el-button plain  @click="centerDialogVisible = false">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit">确认</el-button>
        </div>
  </div>
        </el-dialog>
    </div>
</template>
<script>
import { enCheckHaveDuplicate,enimportSave} from "@/api/enterprise/index"; //重复检查、导入试题
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import topicTemplate from "@/views/testPaper/topicList/addTopic/index.vue"; //将题目列表页面作为组件使用
export default {
    name:'twoSteps',
    components: {
        topicSteps,
        topicTemplate
    },
     props: {
    twoPropType:[String, Number],
    twoPropData:[String, Number]
  },
    data () {
        return {
            sortedIndexes:[],
            loading:false,
            propList:[],
            itemList:[],
            duplicateNum:'',
            totalNum:'',
            propData:{},
            propIndex:'',
            centerDialogVisible:false,
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            propList1:[
            {
                steps:1,
                text:'上传模版',
            },
            {
                steps:2,
                text:'检查试题',
            },{
                steps:3,
                text:'系统检查',
            },{
                steps:4,
                text:'导入试题', 
            }

        ]
        }
    },
    created () {
              let decryptQuery= this.twoPropType ? this.$base64.decode(this.twoPropData) : this.$base64.decode(this.$route.query.data) // 解密
              this.propList = JSON.parse(decryptQuery)
              this.getList()
    },
    methods: {
          // 取消导入
        cacelIM(){
            if(this.twoPropType){
              this.$emit('sendStatus1',false)
          }else{
            this.$router.push('/teacheManage/questionImport')
          }
            this.importTopic = false
        },
        // 接收子组件传输数据
        handleData(data,index){
        // 创建新数组并插入新元素
        let newArr = this.itemList.slice(0,index).concat([data]).concat(this.itemList.slice(index + 1))
        this.itemList = newArr
         this.centerDialogVisible = false 
        },
         onSubmit(){
              this.$refs.topicTemplate.emitData()  
        },
           // 展开处理
        openTopicRe(isTrue,index,data){
            this.itemList[index].isTrue = !isTrue
               if(data.type == 7){
                    // 创建一个包含原数组索引和值的数组  
                        let indexedArray = data.answerList.map((item, index) => ({ item, index }));  
                        // 根据sort值进行排序  
                        indexedArray.sort((a, b) => a.item.sort - b.item.sort);      
                        // 提取排序后的索引  
                        this.sortedIndexes = indexedArray.map(item => item.index);  
                }
        },
        // 删除试题
        deletTopic(index){
          this.$confirm('您确定要删除该试题吗？删除后会影响添加了该题的试卷，请您谨慎操作！?', '删除试题', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        let delet= this.itemList.filter((item,sy)=> sy != index) 
        this.itemList = delet
        })
        },
           // 编辑试题
        editTopic(propData,index){
            this.propData = propData
            this.propIndex = index
            this.centerDialogVisible = true
        },
        // 获取检查数据
     getList(){
         enCheckHaveDuplicate(this.propList,'enterprise')
            .then(res => {
              this.duplicateNum = res.data.duplicateNum
              this.totalNum = res.data.totalNum
               let arr = res.data.questionVOList
              arr.forEach(e => {
                e['isTrue'] = false
              });
              this.itemList = arr
            })
            .catch(err => {
            })
     },
    //  导入试题
    importSvae(){
        this.loading = true;
        enimportSave(this.itemList,'enterprise')
            .then(res => {
              this.loading = false
              if(res.code == 0){
                 this.$bus.$emit("importTopic",false);
                 if(this.twoPropType){
                    this.$emit('sendStatus',res.data)
                 }else{
                   this.$router.push("/teacheManage/questionList")
                 }
                this.reload()
              }
            })
            .catch(err => {
                 this.loading = false
            })
    }, 
    }
}
</script>
<style lang="scss" scoped>
.public-list-container{
    position: relative;
    .public-list-container-table{
         .pustclass{
            width: 15%;
            text-align: center;
          }
          .stsort{
            width: 40% !important;
            text-align: center;
             overflow: hidden;
                    text-overflow: ellipsis;
                    white-space:nowrap
          }
        .public-list-container-table-row {
            padding: 30px 0 !important;
            .pdd{
                padding-bottom: 30px;
            }
           
        }
        .topicIstru{
                border-top: solid 1px #ccc;
                padding: 30px 10px;
            .duplicate-questions{
                
                .duplicate-question{
                    max-width: 50%;
                    flex: 1 1 50%;
                    padding-right: 15px;
                    padding-left: 15px;
                    margin-bottom: 10px;
                    box-sizing: border-box;
                    .portlet{
                        background: #fafafa;
                        padding: 16px 10px !important;
                        border-radius: 5px;
                        .portlet-head{
                            border-bottom: 0;
                            padding: 0 10px;
                            margin-bottom: 0;
                            color: #fff;
                            .caption{
                               font-size: 16px;
                                color: #333;
                                font-weight: 600;
                                padding: 11px 0 9px 0;
                            }
                            .btn-set{
                                .btn-blue-delete{
                                    font-size: 13px;
                                    line-height: 1.5;
                                    cursor: pointer;
                                    color: #36aafd;
                                    border: 1px solid #36aafd;
                                    padding: 8px 25px !important;
                                    border-radius: 4px !important;
                                    box-sizing: border-box;
                                    margin-right: 5px;
                                }
                                .btn-default{
                                    font-size: 13px;
                                    line-height: 1.5;
                                    cursor: pointer;
                                    color: #fff;
                                    background-color: #36aafd;
                                    padding: 8px 25px !important;
                                    border: 1px solid #36aafd;
                                    border-radius: 4px !important;
                                }
                            }
                        }
                        .portlet-body{
                            padding: 10px;
                            .duplication-info-container{
                                .ques-title {
                                    position: relative;
                                    padding-right: 50px;
                                    font-size: 17px;
                                    vertical-align: middle;
                                    line-height: 1.5;
                                    -webkit-margin-before: 0;
                                    -webkit-margin-after: 0;
                                    word-break: break-word;
                                    .ques-type{
                                      background-color: #387dfe;
                                        color: #fff;
                                        padding: 3px 12px;
                                        border: none;
                                        font-size: 12px;
                                        width: 60px;
                                        text-align: center;
                                    }
                                    .qcotent{
                                        padding: 0 10px;
                                        font-size: 15px;
                                    }
                                    .ques-score{
                                        position: absolute;
                                        top: 0px;
                                        right: 10px;
                                        color: #000;
                                    }
                                }
                                .question-option-list{
                                    padding: 0 20px;
                                    margin-top: 10px;
                                    li{
                                        list-style-type: upper-latin;
                                        margin-bottom: 15px;
                                        font-size: 14px;
                                    }
                                    li::marker{
                                       unicode-bidi: isolate;
                                    font-variant-numeric: tabular-nums;
                                    text-transform: none;
                                    text-indent: 0px !important;
                                    text-align: start !important;
                                    text-align-last: start !important; 
                                    }
                                }
                                .ques-answers{
                                    .test_result{
                                        margin-bottom: 8px;
                                       .rightAnswer{
                                            color: #36aafd;
                                            display: block;
                                            font-size: 16px;
                                       } 
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>